module.exports = __webpack_public_path__ + "static/img/404.5cd6e4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.jpg
// module id = zhm8
// module chunks = 12